import {
  createApp
} from 'vue'
import App from './App.vue'
import './assets/css/main.scss'
import router from './router'
import store from './store'
import i18n from './i18n'
import { Locale, Tabs, Tab, Form, Field, CellGroup, Dialog, List, Grid, GridItem, Collapse, CollapseItem, ImagePreview, Toast, Popup, Badge } from 'vant'
import 'vant/lib/index.css'
import VueLuckyCanvas from '@lucky-canvas/vue'
import enUS from 'vant/es/locale/lang/en-US'
import { initializeApp } from 'firebase/app'
import { getAnalytics, setUserId } from 'firebase/analytics'
import { getCookieValue } from './utils'

const firebaseConfig = {
  apiKey: 'AIzaSyAGQbJey3ft99ogvrLrs936UJI0BEgr7xc',
  authDomain: 'vgo-web-7fd8c.firebaseapp.com',
  projectId: 'vgo-web-7fd8c',
  storageBucket: 'vgo-web-7fd8c.appspot.com',
  messagingSenderId: '574466834733',
  appId: '1:574466834733:web:586e4c0262e3c4f5e693a4',
  measurementId: 'G-NXLJB90RL6'
}

const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(Tabs)
  .use(Tab)
  .use(Form)
  .use(Field)
  .use(CellGroup)
  .use(List)
  .use(Grid)
  .use(GridItem)
  .use(Dialog)
  .use(Collapse)
  .use(CollapseItem)
  .use(VueLuckyCanvas)
  .use(Popup)
  .use(ImagePreview)
  .use(Badge)
  .use(Toast)
  .mount('#app')
Locale.use('en-US', enUS)

const firebaseApp = initializeApp(firebaseConfig)
const analytics = getAnalytics(firebaseApp)

// 设置 Firebase 用户唯一标识
const vgoUserId = getCookieValue('vgo-user-id')
if (vgoUserId) {
  setUserId(analytics, vgoUserId)
}
